
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generateCourse, generateIntermediateCourse, generateAdvancedCourse, submitLessonTest, getLessonStatus, getTaskStatus, getCourseList } from '../Services/course.service';

interface CourseState {
  loading: boolean;
  intermediateLoading: boolean;
  advancedLoading: boolean;
  error: string | null;
  success: boolean;
  task_id: number | null;
  intermediate_task_id:number|null;
  advance_task_id:number|null;
  course: any;
  intermediateCourse: any;
  advancedCourse: any;
  startBegineer: boolean;
  startIntermediate: boolean;
  startAdvanced: boolean;
  testDetails:any;
  reviewAnswer:any;
  lessonStatus:any;
  courseList:any;
  status:any;
  courseGenerationInProgress: boolean;
}

const initialState: CourseState = {
  loading: false,
  intermediateLoading: false,
  advancedLoading: false,
  error: null,
  success: false,
  task_id: null,
  intermediate_task_id:null,
  advance_task_id:null,
  course: null,
  intermediateCourse: null,
  advancedCourse: null,
  startBegineer: false,
  startIntermediate: false,
  startAdvanced: false,
  testDetails:null,
  reviewAnswer:false,
  lessonStatus:null,
  courseList: null,
  status:null,
  courseGenerationInProgress: false,
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {

    startIntermediateCourse: (state) => {
      state.startIntermediate = true;

    },
    startAdvancedCourse: (state) => {
      state.startAdvanced = true;
    },
    startBegineerCourse: (state) => {
      state.startBegineer = true;
    },
    reviewAnswer:(state, action: PayloadAction<boolean | undefined>)=>{
      state.reviewAnswer = action.payload !== undefined ? action.payload : !state.reviewAnswer;
    },
    clearTestDetails: (state) => {
      state.testDetails = null;
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(generateCourse.pending, (state) => {
        //state.loading = true;
        state.error = null;
        state.success = false;
        state.courseGenerationInProgress = true;
      })
      .addCase(generateCourse.fulfilled, (state, action) => {
        //state.loading = false;
        state.success = action.payload.success;
        state.task_id = action.payload.task_id;
        localStorage.setItem('taskId', action.payload.task_id);
        //state.course = action.payload.course;
      })
      .addCase(generateCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'Failed to generate course';
        state.success = false;
        state.courseGenerationInProgress = false;
      })
      .addCase(generateIntermediateCourse.pending, (state) => {
        state.intermediateLoading = true;
        state.error = null;
        state.success = false;
        state.courseGenerationInProgress = true;
      })
      .addCase(generateIntermediateCourse.fulfilled, (state, action) => {
        state.intermediateLoading = false;
        state.success = action.payload.success;
        state.intermediate_task_id = action.payload.task_id;
        localStorage.setItem('intermediatetaskid',action.payload.task_id);
      })
      .addCase(generateIntermediateCourse.rejected, (state, action) => {
        state.intermediateLoading = false;
        state.error = action.payload as string || 'Failed to generate course';
        state.success = false;
        state.courseGenerationInProgress = false;
      })
      .addCase(generateAdvancedCourse.pending, (state) => {
        state.advancedLoading = true;
        state.error = null;
        state.success = false;
        state.courseGenerationInProgress = true;
      })
      .addCase(generateAdvancedCourse.fulfilled, (state, action) => {
        state.advancedLoading = false;
        state.success = action.payload.success;
        state.advance_task_id = action.payload.task_id;
        localStorage.setItem('advancetaskid',action.payload.task_id);
      })
      .addCase(generateAdvancedCourse.rejected, (state, action) => {
        state.advancedLoading = false;
        state.error = action.payload as string || 'Failed to generate course';
        state.success = false;
        state.courseGenerationInProgress = false;
      })
      .addCase(submitLessonTest.pending, (state) => {
        state.testDetails = null;
      })
      .addCase(submitLessonTest.fulfilled,(state,action)=>{
        state.testDetails=action.payload;
      })
      .addCase(getTaskStatus.fulfilled, (state, action) => {
        state.status=action.payload.status;
        if (action.payload.status === "PENDING") {
          state.loading = true;
        } else {
          state.loading = false;
          
          // Check if we have a result with course data
          if (action.payload.result && action.payload.result.course) {
            // Course data arrived — generation is complete
            state.courseGenerationInProgress = false;
            // Determine which course type based on current task IDs
            if (action.payload.course_type === "intermediate") {
              state.intermediateCourse = {
                ...action.payload.result.course,
                course_type: action.payload.course_type
              };
            } else if (action.payload.course_type === "beginner") {
              state.course = {
                ...action.payload.result.course,
                course_type: action.payload.course_type
              };
            } else if (action.payload.course_type === "advanced") {
              state.advancedCourse = {
                ...action.payload.result.course,
                course_type: action.payload.course_type
              };
            }
          } else {
            //console.log('No course data found in result:', action.payload.result);
          }
        }
      })
      .addCase(getLessonStatus.fulfilled,(state,action)=>{
        state.lessonStatus=action.payload;
      }).addCase(getCourseList.fulfilled, (state, action) => {        
        if (action.payload.status === "PENDING") {
          state.loading = true;
        } else {
          state.loading = false;
          state.courseList=action.payload;      
        }
      });
  },
});
export const {
  startIntermediateCourse,
  startAdvancedCourse,
  startBegineerCourse,
  reviewAnswer,
  clearTestDetails
} = courseSlice.actions;
export default courseSlice.reducer;
